<div class="d-flex gap-3">
  <div class="flex-fill d-flex flex-column gap-2">
    <div class="container-box shadow-none">
      <div class="p-3 d-flex align-items-center gap-3">
        <img src="/assets/images/channel-wizards/airbnb/tokeet-airbnb.webp" alt="" height="45" />
        <div>
          <h6 class="mb-0" i18n>Airbnb</h6>
          <div class="text-sm" i18n>Sync bookings, rates, and guest messages across multiple Airbnb accounts.</div>
        </div>
      </div>
      <div class="border-top p-3">
        <ng-container i18n
          >As an official Airbnb partner, AdvanceCM syncs bookings, inquiries, and guest messages instantly, imports
          your listings, and relays them to Booking.com, Vrbo, and other channels.</ng-container
        >
        <div class="d-flex gap-2 align-items-center mt-3">
          <span class="bg-active2 badge-pill text-sm px-3 py-1" i18n>Listing Creation</span>
          <span class="bg-active2 badge-pill text-sm px-3 py-1" i18n>Rates</span>
          <span class="bg-active2 badge-pill text-sm px-3 py-1" i18n>Bookings</span>
          <span class="bg-active2 badge-pill text-sm px-3 py-1" i18n>Availability</span>
        </div>
      </div>
    </div>

    <div class="container-box shadow-none p-3">
      <h6 i18n>What you need on your Airbnb account</h6>
      <div class="text-sm" i18n>Airbnb rejects the connection unless your Airbnb account has all of these:</div>
      <ul class="mb-0 mt-2">
        <li i18n>Verified email</li>
        <li i18n>Verified phone</li>
        <li i18n>Verified ID</li>
        <li i18n>Profile picture</li>
      </ul>
    </div>

    <app-connect-airbnb-warnings></app-connect-airbnb-warnings>

    <div class="container-box shadow-none">
      <div class="p-3">
        <h6 i18n>Choose how to connect</h6>
        <div>
          <ng-container i18n>Quick Connect authorizes in one step.</ng-container> <br />
          <ng-container i18n>Advance Connect walks you through each step.</ng-container> <br />
          <ng-container i18n>Read the</ng-container><ng-container>&nbsp;</ng-container>
          <a href="javascript:;" openArticleId="jvqj6x3h9j" i18n>step-by-step guide</a>.
        </div>
      </div>
      <div
        class="alert alert-danger d-flex align-items-center justify-content-between gap-3 mx-3 mb-0"
        *ngIf="errorMessage && !isAuthorizing"
      >
        <div>
          <i class="fas fa-exclamation-circle"></i>
          {{ errorMessage }}
        </div>
        <button class="btn btn-sm btn-outline-danger flex-shrink-0" (click)="onQuick()" i18n>Retry</button>
      </div>
      <div class="d-flex align-items-center justify-content-end gap-3 border-top p-3">
        <button class="btn btn-danger" (click)="onQuick()" [disabled]="isAuthorizing">
          <i class="cs-icon cs-icon-time-counter" *ngIf="!isAuthorizing"></i>
          <i class="far fa-spin fa-spinner" *ngIf="isAuthorizing"></i>
          <ng-container i18n>Quick Connect</ng-container>
        </button>
        <button class="btn btn-secondary-info" (click)="onAdvance()" [disabled]="isAuthorizing">
          <i class="cs-icon cs-icon-double-arrow-right" *ngIf="!isAuthorizing"></i>
          <i class="far fa-spin fa-spinner" *ngIf="isAuthorizing"></i>
          <ng-container i18n>Advance Connect</ng-container>
        </button>
      </div>
    </div>
  </div>
  <div class="channel-wizard-right-wrapper rounded px-4">
    <img src="/assets/images/channel-wizards/airbnb/airbnb-step1.webp" alt="" />
  </div>
</div>
